<template>
  <div class="overlay overlay__region">
    <div class="region-info">
        <div class="region-info_holder">
            <p class="region-info_title">{{ $t('Выбери страну выпуска и получения карты') }}</p>
            <p class="region-info_description">{{ availabilityText }}</p>
            <RegionSelector @selected="close" />
        </div>
    </div>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import RegionSelector from './RegionSelector.vue'

@Component({
  components: { RegionSelector }
})
class RegionInfoOverlay extends Vue {
  get availabilityText () {
    // Text can include linebreaks on different languages
    return this.$t('Обращаем внимание, что в данный момент программа действует только в ограниченном списке стран:', { 'br': '<br/>' })
  }

  close () {
    this.$emit('close')
  }
}

export default RegionInfoOverlay
</script>

<style lang="scss">
.region-info {
  background: #000;
  overflow: hidden;
  text-align: center;
  padding: 55px 0;
  position: relative;
  z-index: 2;

  &_holder {
    max-width: 650px;
    margin: 0 auto;
    padding: 0 20px;
  }
  &_title {
    color: #fff;
    font-size: 18px;
    line-height: 1.3;
    margin-bottom: 20px;
    @include media_mobile_m {
      font-size: 24px;
      margin-bottom: 30px;
    }
  }
  &_description {
    margin-bottom: 25px;
    @include media_mobile_m {
      font-size: 16px;
      max-width: 580px;
      margin: 0 auto 34px;
    }
  }
}

.overlay {
  background-color: #000;
  display: none;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  width: 100%;
  z-index: $common-menu_z-index + 1;
  transition: opacity $duration;

  &__region {
    display: block;
    background: rgba(10, 10, 11, .6);
  }
}
</style>
